import { Skeleton } from '@mantine/core';

import type { SkeletonProps } from '../shared/helpers.ts';

export function CartesianSkeleton({ height, columns: _columns, rows: _rows }: SkeletonProps) {
  return <Skeleton animate height={height ?? '100%'} radius="sm" width="100%" />;
}
